import { defineComponent, PropType } from "vue";
import { mapActions } from "pinia";

import { formatUserInitials } from "../../../../common/vue-helpers/modifiers/format-message";
import { getUserStatusClass } from "../../../../common/vue-helpers/solution-color-index";
import { AvaInitialsType } from "../../../../enums/ConversationTypeEnum";
import { IConversationUser } from "../../../../resources-vue/vue-interfaces/messaging-service/i-message";
import { useUserStore } from "../../store/useUsersStore";

export default defineComponent({
    props: {
        classes: {
            type: String,
            default: ""
        },
        initialsType: {
            type: Number as PropType<AvaInitialsType>,
            default: AvaInitialsType.Group
        },
        user: {
            type: Object as PropType<IConversationUser>,
            default: {}
        },
        showStatus: {
            type: Boolean,
            default: false
        },
        isDraftConv: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            imageUrl: null as string,
            statusDetails: null as any,
            formatUserInitials,
            AvaInitialsType
        };
    },

    async mounted() {
        this.imageUrl = await this.fetchImage(this.user.loginId, this.user.profilePicId);
    },

    watch: {
        async "statusDetails.profilePicId"(newImageId) {
            this.imageUrl = await this.fetchImage(this.user.loginId, newImageId);
        }
    },

    computed: {
        getInitialsClass() {
            const userStore = useUserStore();
            this.statusDetails = userStore.getUserStatusDetails(this.user.loginId);
            if (this.initialsType == AvaInitialsType.Single) {
                let classStr = "";
                if (this.showStatus) {
                    classStr = `ava-status ${getUserStatusClass(this.statusDetails.currentStatus)}`;
                }
                if (this.imageUrl) {
                    return classStr;
                } else {
                    return `${classStr} ava-initials-${this.statusDetails.profileColor}`;
                }
            } else {
                return "";
            }
        }
    },

    methods: {
        ...mapActions(useUserStore, ["fetchImage"])
    }
});
